import { useNavigate } from "react-router";
import { useSelectedSites } from "../../..";
import { classes } from "../../../helper";
import AllSitesPill from "./AllSitesPill";
import styles from "./CompactContent.module.css";
import { MODULE } from "./constants";
import { getAllSitesSelection } from "./getAllSitesSelection";
import ProductionAreaTabs from "./ProductionAreaTabs";
import SiteNav from "./SiteNav";
import shared from "./SiteSelector.module.css";
import { ContentProps } from "./types";

function CompactContent({
  site,
  sites,
  productionAreaTabs,
  activeProductionArea,
  setActiveProductionArea,
  setIsOpen,
  getSiteUrl,
  allowMultiSite = true,
  getMultiSiteUrl,
}: ContentProps) {
  const { selectedSites, setSelected } = useSelectedSites();
  const navigate = useNavigate();

  const close = () => setIsOpen(false);

  const handleSelect = (siteName: string) => {
    setSelected([siteName]);
    if (getMultiSiteUrl) {
      navigate(getMultiSiteUrl([siteName]));
    }
    close();
  };

  return (
    <div className={styles.compact}>
      {productionAreaTabs.length > 1 && (
        <div className={styles.compactHeaderBar}>
          <ProductionAreaTabs
            tabs={productionAreaTabs}
            activeProductionArea={activeProductionArea}
            onSelect={setActiveProductionArea}
          />
        </div>
      )}
      <div className={styles.compactColumn}>
        <AllSitesPill
          variant="row"
          disabled={!allowMultiSite}
          onSelectAll={() => {
            setSelected(getAllSitesSelection(sites));
            close();
          }}
        />
        {sites?.map((p) => {
          const isCurrent = selectedSites.includes(p.site) || p.site === site;
          const rowClass = classes(
            styles.compactRow,
            isCurrent ? styles.compactRowCurrent : ""
          );

          if (!p.moduleEnabled) {
            return (
              <div
                key={p.site}
                className={classes(rowClass, shared.disabled)}
                title={`${p.site} does not have ${MODULE} enabled.`}
              >
                <span className={shared.siteName}>{p.site}</span>
              </div>
            );
          }

          return getSiteUrl ? (
            <SiteNav
              key={p.site}
              to={getSiteUrl(p)}
              onClick={close}
              className={rowClass}
            >
              <span className={shared.siteName}>{p.site}</span>
            </SiteNav>
          ) : (
            <div
              key={p.site}
              className={rowClass}
              onClick={() => handleSelect(p.site)}
            >
              <span className={shared.siteName}>{p.site}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default CompactContent;
